import React from 'react'

const WithdrawalDE = () => {
    return (
        <>
            <meta content="text/html; charset=UTF-8" httpEquiv="content-type" />
            <style
                type="text/css"
                dangerouslySetInnerHTML={{
                    __html: 'ol{margin:0;padding:0}table td,table th{padding:0}.c0{padding-top:0pt;padding-bottom:10pt;line-height:1.1500000000000001;page-break-after:avoid;orphans:2;widows:2;text-align:left}.c2{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:12pt;font-family:"Albert Sans";font-style:normal}.c7{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-family:"Albert Sans";font-style:normal}.c1{padding-top:0pt;padding-bottom:10pt;line-height:1.1500000000000001;orphans:2;widows:2;text-align:justify}.c5{text-decoration-skip-ink:none;font-size:12pt;-webkit-text-decoration-skip:none;color:#1155cc;text-decoration:underline}.c10{background-color:#ffffff;max-width:451.5pt;padding:72pt 72pt 72pt 72pt}.c9{color:inherit;text-decoration:inherit}.c6{font-size:12pt}.c4{font-size:26pt}.c8{font-size:11pt}.c3{height:11pt}.title{padding-top:0pt;color:#000000;font-size:26pt;padding-bottom:3pt;font-family:"Albert Sans";line-height:1.1500000000000001;page-break-after:avoid;orphans:2;widows:2;text-align:left}.subtitle{padding-top:0pt;color:#666666;font-size:15pt;padding-bottom:16pt;font-family:"Albert Sans";line-height:1.1500000000000001;page-break-after:avoid;orphans:2;widows:2;text-align:left}li{color:#000000;font-size:11pt;font-family:"Albert Sans"}p{margin:0;color:#000000;font-size:11pt;font-family:"Albert Sans"}h1{padding-top:20pt;color:#000000;font-size:20pt;padding-bottom:6pt;font-family:"Albert Sans";line-height:1.1500000000000001;page-break-after:avoid;orphans:2;widows:2;text-align:left}h2{padding-top:18pt;color:#000000;font-size:16pt;padding-bottom:6pt;font-family:"Albert Sans";line-height:1.1500000000000001;page-break-after:avoid;orphans:2;widows:2;text-align:left}h3{padding-top:16pt;color:#434343;font-size:14pt;padding-bottom:4pt;font-family:"Albert Sans";line-height:1.1500000000000001;page-break-after:avoid;orphans:2;widows:2;text-align:left}h4{padding-top:14pt;color:#666666;font-size:12pt;padding-bottom:4pt;font-family:"Albert Sans";line-height:1.1500000000000001;page-break-after:avoid;orphans:2;widows:2;text-align:left}h5{padding-top:12pt;color:#666666;font-size:11pt;padding-bottom:4pt;font-family:"Albert Sans";line-height:1.1500000000000001;page-break-after:avoid;orphans:2;widows:2;text-align:left}h6{padding-top:12pt;color:#666666;font-size:11pt;padding-bottom:4pt;font-family:"Albert Sans";line-height:1.1500000000000001;page-break-after:avoid;font-style:italic;orphans:2;widows:2;text-align:left}'
                }}
            />
            <p className="c1">
                <span className="c2">Widerrufsbelehrung Deutschland</span>
            </p>
            <p className="c1">
                <span className="c2">Stand: März 2024 </span>
            </p>
            <p className="c1">
                <span className="c2">
                    Ist der Mieter Verbraucher, gelten für den Abschluss des Mietvertrags folgende Regelungen:
                </span>
            </p>
            <p className="c1">
                <span className="c2">Widerrufsrecht</span>
            </p>
            <p className="c1">
                <span className="c6">
                    Der Verbraucher hat das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu
                    widerrufen. Die vierzehntägige Widerrufsfrist beginnt mit dem Vertragsschluss. Der Widerruf ist
                    gegenüber dem Vermieter zu erklären. Widerrufserklärungen können zu diesem Zweck auch gegenüber der
                    Wemolo GmbH (St.-Martin-Straße 72, 81541 München, Tel.: +49 89 693146491,{' '}
                </span>
                <span className="c5">
                    <a className="c9" href="mailto:book@wemolo.com">
                        book@wemolo.com
                    </a>
                </span>
                <span className="c2">
                    ), erfolgen (z. B. per Brief, Telefax oder E-Mail), die vom Vermieter zur Entgegennahme solcher
                    Erklärungen bevollmächtigt ist. Der Entschluss zum Widerruf des Vertrags muss eindeutig aus dieser
                    Erklärung hervorgehen. Der Verbraucher kann hierzu das beigefügte Muster-Widerrufsformular
                    verwenden. Zur Fristwahrung genügt die rechtzeitige Absendung des Widerrufs.{' '}
                </span>
            </p>
            <p className="c1">
                <span className="c2">Folgen des Widerrufs</span>
            </p>
            <p className="c1">
                <span className="c2">
                    Widerruft der Verbraucher den Vertrag, werden ihm sämtliche Zahlungen, die zu diesem Zeitpunkt
                    bereits vom Verbraucher erbracht wurden, unverzüglich und spätestens binnen vierzehn Tagen nach
                    Zugang der Widerrufserklärung durch die Wemolo GmbH zurückgewährt. Die Rückzahlung erfolgt über
                    dasselbe Zahlungsmittel, das bei der ursprünglichen Transaktion eingesetzt wurde. Etwaige Entgelte
                    im Zusammenhang mit der Rückzahlung werden nicht berechnet.{' '}
                </span>
            </p>
            <p className="c1">
                <span className="c2">
                    Verlangt der Mieter ausdrücklich, dass ihm der Stellplatz bereits vor Ablauf der vierzehntägigen
                    Widerrufsfrist vertragsgemäß zum Gebrauch überlassen wird, wird die in diesem Zeitraum bis zum
                    Eingang des Widerrufs angefallene, anteilige Miete als Wertersatz für die bereits erbrachten
                    Leistungen einbehalten.
                </span>
            </p>
            <p className="c1">
                <span className="c2">Ende der Widerrufsbelehrung</span>
            </p>
            <p className="c1 c3">
                <span className="c2" />
            </p>
            <hr />
            <p className="c1 c3">
                <span className="c2" />
            </p>
            <p className="c1 c3">
                <span className="c2" />
            </p>
            <p className="c1">
                <span className="c2">Muster-Widerrufsformular</span>
            </p>
            <p className="c1">
                <span className="c2">
                    (Wenn Sie den Vertrag widerrufen wollen, dann füllen Sie bitte dieses Formular aus und senden Sie es
                    zurück.)
                </span>
            </p>
            <p className="c1">
                <span className="c6">An die Wemolo GmbH, St.-Martin-Straße 72, 81541 München, </span>
                <span className="c5">
                    <a className="c9" href="mailto:book@wemolo.com">
                        book@wemolo.com
                    </a>
                </span>
                <span className="c2">:</span>
            </p>
            <p className="c1">
                <span className="c2">
                    Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*) abgeschlossenen Mietvertrag
                </span>
            </p>
            <p className="c1">
                <span className="c2">Bestellt am (*)/erhalten am (*)</span>
            </p>
            <p className="c1">
                <span className="c2">Name des/der Verbraucher(s)</span>
            </p>
            <p className="c1">
                <span className="c2">Anschrift des/der Verbraucher(s)</span>
            </p>
            <p className="c1">
                <span className="c2">Unterschrift des/der Verbraucher(s) (nur bei Mitteilung auf Papier)</span>
            </p>
            <p className="c1">
                <span className="c2">Datum</span>
            </p>
            <p className="c1">
                <span className="c2">(*) Unzutreffendes streichen</span>
            </p>
            <hr />
            <p className="c1 c3">
                <span className="c2" />
            </p>
            <p className="c1 c3">
                <span className="c2" />
            </p>
            <p className="c1">
                <span className="c2">Widerrufsbelehrung Österreich</span>
            </p>
            <p className="c1">
                <span className="c2">Stand: März 2024 </span>
            </p>
            <p className="c1">
                <span className="c2">
                    Ist der Mieter Verbraucher, gelten für den Abschluss des Mietvertrags folgende Regelungen:
                </span>
            </p>
            <p className="c1">
                <span className="c2">Widerrufsrecht</span>
            </p>
            <p className="c1">
                <span className="c6">
                    Der Verbraucher hat das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu
                    widerrufen. Die vierzehntägige Widerrufsfrist beginnt mit dem Vertragsschluss. Der Widerruf ist
                    gegenüber dem Vermieter zu erklären. Widerrufserklärungen können zu diesem Zweck auch gegenüber der
                    ParkDepot GmbH, Siezenheimerstraße 35, 5020 Salzburg, Tel.: +43 720 880680,{' '}
                </span>
                <span className="c5">
                    <a className="c9" href="mailto:book@wemolo.at">
                        book@wemolo.at
                    </a>
                </span>
                <span className="c2">
                    ), erfolgen (z. B. per Brief, Telefax oder E-Mail), die vom Vermieter zur Entgegennahme solcher
                    Erklärungen bevollmächtigt ist. Der Entschluss zum Widerruf des Vertrags muss eindeutig aus dieser
                    Erklärung hervorgehen. Der Verbraucher kann hierzu das beigefügte Muster-Widerrufsformular
                    verwenden. Zur Fristwahrung genügt die rechtzeitige Absendung des Widerrufs.{' '}
                </span>
            </p>
            <p className="c1">
                <span className="c2">Folgen des Widerrufs</span>
            </p>
            <p className="c1">
                <span className="c2">
                    Widerruft der Verbraucher den Vertrag, werden ihm sämtliche Zahlungen, die zu diesem Zeitpunkt
                    bereits vom Verbraucher erbracht wurden, unverzüglich und spätestens binnen vierzehn Tagen nach
                    Zugang der Widerrufserklärung durch die ParkDepot GmbH zurückgewährt. Die Rückzahlung erfolgt über
                    dasselbe Zahlungsmittel, das bei der ursprünglichen Transaktion eingesetzt wurde. Etwaige Entgelte
                    im Zusammenhang mit der Rückzahlung werden nicht berechnet.{' '}
                </span>
            </p>
            <p className="c1">
                <span className="c2">
                    Verlangt der Mieter ausdrücklich, dass ihm der Stellplatz bereits vor Ablauf der vierzehntägigen
                    Widerrufsfrist vertragsgemäß zum Gebrauch überlassen wird, wird die in diesem Zeitraum bis zum
                    Eingang des Widerrufs angefallene, anteilige Miete als Wertersatz für die bereits erbrachten
                    Leistungen einbehalten.
                </span>
            </p>
            <p className="c1">
                <span className="c2">Ende der Widerrufsbelehrung</span>
            </p>
            <p className="c1 c3">
                <span className="c2" />
            </p>
            <hr />
            <p className="c1 c3">
                <span className="c2" />
            </p>
            <p className="c1 c3">
                <span className="c2" />
            </p>
            <p className="c1">
                <span className="c2">Muster-Widerrufsformular</span>
            </p>
            <p className="c1">
                <span className="c2">
                    (Wenn Sie den Vertrag widerrufen wollen, dann füllen Sie bitte dieses Formular aus und senden Sie es
                    zurück.)
                </span>
            </p>
            <p className="c1">
                <span className="c6">
                    An die ParkDepot GmbH, Siezenheimerstraße 35, 5020 Salzburg, Tel.: +43 720 880680,{' '}
                </span>
                <span className="c5">
                    <a className="c9" href="mailto:book@wemolo.at">
                        book@wemolo.at
                    </a>
                </span>
                <span className="c2">:</span>
            </p>
            <p className="c1">
                <span className="c2">
                    Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*) abgeschlossenen Mietvertrag
                </span>
            </p>
            <p className="c1">
                <span className="c2">Bestellt am (*)/erhalten am (*)</span>
            </p>
            <p className="c1">
                <span className="c2">Name des/der Verbraucher(s)</span>
            </p>
            <p className="c1">
                <span className="c2">Anschrift des/der Verbraucher(s)</span>
            </p>
            <p className="c1">
                <span className="c2">Unterschrift des/der Verbraucher(s) (nur bei Mitteilung auf Papier)</span>
            </p>
            <p className="c1">
                <span className="c2">Datum</span>
            </p>
            <p className="c1">
                <span className="c6">(*) Unzutreffendes streichen</span>
            </p>
        </>
    )
}

export default WithdrawalDE
